export type ServiceIcon =
  | "RocketLaunch"
  | "Architecture"
  | "Language"
  | "MiscellaneousServices"
  | "Build"
  | "SupportAgent";

export interface ServiceItem {
  icon: ServiceIcon;
  titleKey: string;
  textKey: string;
  details?: string[];
}

export const services: ServiceItem[] = [
  {
    icon: "RocketLaunch",
    titleKey: "processOptimization",
    textKey: "processOptimizationText",
    details: [
      "Ist‑Analyse und KPI‑Definition",
      "Automatisierung mit Low‑Code/CI/CD",
      "Dashboards & Monitoring",
    ],
  },
  {
    icon: "Architecture",
    titleKey: "softwareDevelopment",
    textKey: "softwareDevelopmentText",
    details: [
      "Full‑Stack TypeScript/React/NestJS",
      "Spring Boot Microservices",
      "API‑Design, Tests & Doku",
    ],
  },
  {
    icon: "Language",
    titleKey: "webSeo",
    textKey: "webSeoText",
    details: [
      "Performance‑Optimierung (Core Web Vitals)",
      "On‑Page SEO & Structured Data",
      "CMS oder Headless je nach Bedarf",
    ],
  },
  {
    icon: "MiscellaneousServices",
    titleKey: "automation",
    textKey: "automationText",
    details: [
      "Workflow‑Automatisierung (z. B. Zapier, n8n)",
      "KI‑Assistenten & Klassifikationen",
      "Datenpipelines & Integrationen",
    ],
  },
  {
    icon: "Build",
    titleKey: "itService",
    textKey: "itServiceText",
    details: [
      "Microsoft 365 / Google Workspace",
      "Backups & Sicherheit",
      "Geräteverwaltung (MDM)",
    ],
  },
  {
    icon: "SupportAgent",
    titleKey: "support",
    textKey: "supportText",
    details: [
      "Einführung neuer Tools",
      "Team‑Workshops & Trainings",
      "Dokumentation & FAQ",
    ],
  },
];
